import PostModel, { PermissionType } from "app/models/PostModel";

export const hasPermission = (
  post: PostModel,
  permission: PermissionType,
): boolean => {
  return post?.permissions?.includes(permission) ?? false;
};

export const hasPlanPermission = (
  post: PostModel,
  permission: PermissionType,
): boolean => {
  return post?.planPermissions?.includes(permission) ?? false;
};

export const hasFullPermission = (
  post: PostModel,
  permission: PermissionType,
): boolean => {
  return hasPermission(post, permission) && hasPlanPermission(post, permission);
};

export const canMove = (post: PostModel) => hasFullPermission(post, "move");

export const canCopy = (post: PostModel) => hasFullPermission(post, "copy");

export const canAddToRecruit = (post: PostModel) =>
  hasFullPermission(post, "create_recruit_milestone");

export const canReply = (post: PostModel) => {
  if (post?.spacesCount > 0) {
    return false;
  }
  return hasFullPermission(post, "reply");
};

export const canTag = (post: PostModel) => hasPermission(post, "tag");

export const canPin = (post: PostModel) => hasPermission(post, "pin");

export const canDelete = (post: PostModel) => hasPermission(post, "delete");

export const canEdit = (post: PostModel) => hasPermission(post, "edit");

export const canLike = (post: PostModel) => hasPermission(post, "like");

export const canSeePostData = (post: PostModel) => {
  return (
    hasPermission(post, "access_views") && hasPermission(post, "access_likes")
  );
};

export const planCanTag = (post: PostModel) => hasPlanPermission(post, "tag");

export const planCanDelete = (post: PostModel) =>
  hasPlanPermission(post, "delete");

export const planCanEdit = (post: PostModel) => hasPlanPermission(post, "edit");

export const planCanPin = (post: PostModel) => hasPlanPermission(post, "pin");

export const planCanReply = (post: PostModel) =>
  hasPlanPermission(post, "reply");

export const planCanLike = (post: PostModel) => hasPlanPermission(post, "like");
